import { render, staticRenderFns } from "./PersonPasswordModal.vue?vue&type=template&id=0fc00c26&scoped=true"
import script from "./PersonPasswordModal.vue?vue&type=script&lang=js"
export * from "./PersonPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./PersonPasswordModal.vue?vue&type=style&index=0&id=0fc00c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc00c26",
  null
  
)

export default component.exports